jQuery(document).ready(function ($) {


    /* Every time the window is scrolled ... */
    $(window).scroll(function () {

        /* Check the location of each desired element */
        $('.card-0').each(function (i) {

            var bottom_of_object = $(this).offset().top + $(this).outerHeight();
            var bottom_of_window = $(window).scrollTop() + $(window).height();

            /* If the object is completely visible in the window, fade it it */
            if (bottom_of_window > bottom_of_object) {

                $(this).animate({'opacity': '1'}, 2000);

            }

        });
        $('.card-1').each(function (i) {

            var bottom_of_object = $(this).offset().top + $(this).outerHeight();
            var bottom_of_window = $(window).scrollTop() + $(window).height();

            /* If the object is completely visible in the window, fade it it */
            if (bottom_of_window > bottom_of_object) {

                $(this).delay(1100).animate({'opacity': '1'}, 3000);

            }
        });

    });

    $('.count').each(function () {
        $(this).prop('Counter', 0).delay(1500).animate({
            Counter: $(this).text()
        }, {
            duration: 6000,
            easing: 'swing',
            step: function (now) {
                $(this).text(Math.ceil(now));
            }
        });
    });

    // gsap.utils.toArray(".fl-row").forEach(function (elem) {
    //     if (elem.getAttribute('data-color') !== null) {
    //
    //
    //         var color = elem.getAttribute('data-color');
    //         ScrollTrigger.create({
    //             trigger: elem,
    //             start: 'top 60%',
    //             end: 'bottom 60%',
    //             onEnter: () => gsap.to('body', {backgroundColor: color}),
    //             onLeave: () => gsap.to('body', {backgroundColor: color}),
    //             onLeaveBack: () => gsap.to('body', {backgroundColor: color}),
    //             onEnterBack: () => gsap.to('body', {backgroundColor: color}),
    //             markers: true
    //         });
    //     }
    // });

//if inView is on view, add class to the element else remove class
    inView('.panels').on('enter', function (el) {

        $(el).addClass('in-view');
    }).on('exit', function (el) {
        $(el).removeClass('in-view');
    });
    inView('.panels-teal').on('enter', function (el) {

        $(el).addClass('in-view-teal');
    }).on('exit', function (el) {
        $(el).removeClass('in-view-teal');
    });
    inView('.panels-grey').on('enter', function (el) {

        $(el).addClass('in-view-grey');
    }).on('exit', function (el) {
        $(el).removeClass('in-view');
    });


    var animationRemotee = bodymovin.loadAnimation({
        container: document.getElementById('svg__007'),
        path: '/wp-content/themes/beaverwarrior/components/FiftyFiftySection/bw-fifty-fifty-section/includes/img/IconFinalSize.json',
        autoplay: true,
        renderer: 'svg',
        loop: true
    });

    $(document).on('click', '.AnchorLink', function (event) {
        event.preventDefault();

        $('html, body').animate({
            scrollTop: $($.attr(this, 'href')).offset().top - 400
        }, 1000);

    });
    $(document).on('click', '.AnchorLinks', function (event) {
        event.preventDefault();

        $('html, body').animate({
            scrollTop: $($.attr(this, 'href')).offset().top - 250
        }, 900);

    });
});
